import VmChatbotLoader from './vm-chatbot-loader/vm-chatbot-loader';
import VmChatbotSkeleton from './vm-chatbot-skeleton/vm-chatbot-skeleton';

import VmListPagination from './vm-list-pagination/vm-list-pagination';
import VmSortDropdown from './vm-sort-dropdown/vm-sort-dropdown';
import VmLoadingSpinner from './vm-loading-spinner/vm-loading-spinner';
import VmProfileImage from './vm-profile-image/vm-profile-image';

import VmKolProfilePage from './vm-kol-profile-page/vm-kol-profile-page';
import VmKolProfilePageHeader from './vm-kol-profile-page-header/vm-kol-profile-page-header';
import VmKolProfilePageVideoList from './vm-kol-profile-page-video-list/vm-kol-profile-page-video-list';
import VmKolProfilePageVideoListItem from './vm-kol-profile-page-video-list-item/vm-kol-profile-page-video-list-item';

customElements.define('vm-chatbot-loader', VmChatbotLoader);
customElements.define('vm-chatbot-skeleton', VmChatbotSkeleton);

customElements.define('vm-list-pagination', VmListPagination);
customElements.define('vm-sort-dropdown', VmSortDropdown);
customElements.define('vm-loading-spinner', VmLoadingSpinner);
customElements.define('vm-profile-image', VmProfileImage);

customElements.define('vm-kol-profile-page', VmKolProfilePage);
customElements.define('vm-kol-profile-page-header', VmKolProfilePageHeader);
customElements.define('vm-kol-profile-page-video-list', VmKolProfilePageVideoList);
customElements.define('vm-kol-profile-page-video-list-item', VmKolProfilePageVideoListItem);
